import { CloseIcon } from "@chakra-ui/icons"
import {
  Box,
  Button,
  Divider,
  IconButton,
  Text,
  useToast,
} from "@chakra-ui/react"

const CustomToast = ({
  message,
  description,
  title,
  errorCode,
  onConfirm,
}: {
  title?: string
  description?: string
  message: string
  errorCode?: boolean
  onConfirm?: () => void
}) => {
  const toast = useToast()
  const handleClose = () => {
    toast.closeAll()
  }
  return (
    <Box bg='white' w={"full"} shadow={"xl"}>
      <Box
        bg={errorCode ? "white" : "secondary.1000"}
        display={"flex"}
        justifyContent={title ? "space-between" : "end"}
        alignItems={"center"}
        p={2}
      >
        {title && <Text fontWeight={600}>{title}</Text>}
        <IconButton
          aria-label='close toast'
          variant='icon'
          onClick={handleClose}
        >
          <CloseIcon color={errorCode ? "black" : "#fff"} />
        </IconButton>
      </Box>
      {errorCode && <Divider />}
      <Box p={4} my={"10px"}>
        <Text fontWeight={"500"}>{message}</Text>
        {description && (
          <Text mt='1' size='sm'>
            {description}
          </Text>
        )}
      </Box>
      <Divider />
      <Box display={"flex"} alignItems={"center"} justifyContent={"end"} p={3}>
        <Button variant={"ghost"} onClick={handleClose}>
          {errorCode ? "Go back" : "Close"}
        </Button>
        {errorCode && (
          <Button
            ml={2}
            bg='red.500'
            color='white'
            _hover={{ bg: "red.600" }}
            onClick={() => {
              handleClose()
              onConfirm?.() // run confirm callback
            }}
          >
            Cancel booking
          </Button>
        )}
      </Box>
    </Box>
  )
}

export default CustomToast
